export { GET_CONTENT_COLLECTIONS } from './queries'
export { getContentCollections } from './CollectionsService'
export type { ContentCollections, ContentCollection } from './types'
